import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownMenuComponent } from '../ui/dropdown-menu/dropdown-menu.component';
import { LanguageSelector } from './language-selector.dto';

import { ContentStateService } from 'src/app/views/content/content-state.service';
import { inject } from '@angular/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: true,
  imports: [DropdownMenuComponent, TranslateModule],
})
export class LanguageSelectorComponent implements OnInit {
  @Input() showLabel = true;

  selectedLanguage: string = localStorage.getItem('language') || 'fr';
  languages: LanguageSelector[];

  private translate = inject(TranslateService);
  private contentStateService = inject(ContentStateService);

  public isDictating = this.contentStateService.isLiveTranscribing;

  constructor() {}

  ngOnInit(): void {
    this.languages = [
      {
        value: 'fr',
        label: this.translate.instant('LanguageSelector.French'),
        icon: 'flag-fr',
        iconType: 'svg',
      },
      {
        value: 'en',
        label: this.translate.instant('LanguageSelector.English'),
        icon: 'flag-us',
        iconType: 'svg',
      },
    ];

    this.translate.onLangChange.subscribe(() => {
      this.onLangChange();
    });
  }

  onLangChange(): void {
    this.selectedLanguage = this.translate.currentLang;
    this.translate.use(this.selectedLanguage);
    this.languages = [
      {
        value: 'fr',
        label: this.translate.instant('LanguageSelector.French'),
        icon: 'flag-fr',
        iconType: 'svg',
      },
      {
        value: 'en',
        label: this.translate.instant('LanguageSelector.English'),
        icon: 'flag-us',
        iconType: 'svg',
      },
    ];
  }

  setLanguage(lang: any): void {
    this.selectedLanguage = lang.value;
    this.onLanguageChange();
  }

  onLanguageChange(): void {
    this.translate.use(this.selectedLanguage);
    localStorage.setItem('language', this.selectedLanguage);
  }

  getCurrentLanguageName(): any {
    return this.languages.find((element) => element.value === this.translate.currentLang);
  }
}
